"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
const uploadImageCallback = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
        resolve({ data: { link: reader.result } });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
});
exports.defaultOptions = {
    options: [
        "inline",
        // 'blockType',
        "fontSize",
        // 'fontFamily',
        "list",
        // 'textAlign',
        // 'colorPicker',
        // 'link',
        // 'embedded',
        "emoji",
        "image",
        "remove",
        // 'history'
    ],
    inline: {
        options: [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            // 'monospace',
            // 'superscript',
            // 'subscript'
        ],
        bold: { className: "rich-text-editor__toolbar__button" },
        italic: { className: "rich-text-editor__toolbar__button" },
        underline: { className: "rich-text-editor__toolbar__button" },
        strikethrough: { className: "rich-text-editor__toolbar__button" },
        // monospace: { className: 'email-editor__toolbar__button' },
        // superscript: { className: 'email-editor__toolbar__button' },
        // subscript: { className: 'email-editor__toolbar__button' }
    },
    fontSize: {
        // icon: fontSize,
        options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
        className: undefined,
        component: undefined,
        dropdownClassName: undefined,
    },
    fontFamily: {
        options: [
            "Arial",
            "Georgia",
            "Impact",
            "Tahoma",
            "Times New Roman",
            "Verdana",
        ],
        className: undefined,
        component: undefined,
        dropdownClassName: undefined,
    },
    list: {
        options: ["unordered", "ordered"],
        unordered: { className: "rich-text-editor__toolbar__button" },
        ordered: { className: "rich-text-editor__toolbar__button" },
    },
    // link: {
    //   options: ['link', 'unlink'],
    //   link: { className: 'email-editor__toolbar__button' },
    //   unlink: { className: 'email-editor__toolbar__button' }
    // },
    emoji: { className: "rich-text-editor__toolbar__button" },
    image: {
        urlEnabled: false,
        uploadEnabled: true,
        alignmentEnabled: true,
        uploadCallback: uploadImageCallback,
        previewImage: true,
        inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
        defaultSize: {
            height: "64px",
            width: "64px",
        },
        alt: { present: false, mandatory: false },
    },
    remove: { className: "rich-text-editor__toolbar__button" },
    // history: {
    //   options: ['undo', 'redo'],
    //   undo: { className: 'email-editor__toolbar__button' },
    //   redo: { className: 'email-editor__toolbar__button' }
    // }
};
//# sourceMappingURL=default.js.map